export default __webpack_public_path__ + "static/media/square.fde7412b.svg";